import { IIdsRequest } from "../../model/request/IIdsRequest";
import { IBoMon } from "../../model/respone/category/IBoMon";
import { apiClient } from "../apiClient";
export const BO_MON_API = "bo-mon";
export const boMonApi = {
  SelectAll: () => apiClient.get(`${BO_MON_API}`),
  Insert: (payload: IBoMon) => apiClient.post(`${BO_MON_API}`, payload),
  Update: (payload: IBoMon) => apiClient.put(`${BO_MON_API}`, payload),
  Delete: (id: number) => apiClient.delete(`${BO_MON_API}/${id}`),
  Deletes: (rq: IIdsRequest) => apiClient.post(`${BO_MON_API}/deletes`, rq),
};
